import React, { useContext } from 'react'
import { OrdersStepProps } from './types'
import { FileUpload } from './FileUpload'
import { buildBoxesForB2BOrder, buildBoxesForB2COrder } from './utils'
import { MMCCOrderCreationContext } from './MMCCOrderCreationContext'
import { OCMethodSelection } from './OCMethodSelection'
import { ManualKeyboard } from './ManualKeyboard'
import { SERVICE_TYPE, CURRENY_COUNTRY_LABELS, GLOBAL_CURRENCY, OCMethod } from 'containers/FPLCommon/constants'

const OrdersStep = ({ selectedService, saveOCMethod }: OrdersStepProps) => {
  const { ocState, updateOCState } = useContext(MMCCOrderCreationContext)
  const { destination_country: destinationCountry } = ocState.selectedService
  const { validOrders, invalidOrders, allOrders, fileName, validRows, invalidRows, ocMethod } = ocState

  const changeMethod = method => {
    saveOCMethod(method)
  }

  const handleClickOptionButton = type => {
    changeMethod(type)
  }

  const handleProcessDataUpload = (
    {
      allOrders: aOrders,
      validRows: vRows,
      invalidRows: inRows,
      validItemisedOrders: vItemisedOrders,
      invalidItemisedOrders: inItemisedOrders,
      numberOfValidItemsInValidOrders,
      numberOfInvalidItemsInInvalidOrders,
      numberOfValidItemsInInvalidOrders,
      errorsByBoxLevel,
      errorsByParcelLevel
    },
    uploadedFileName
  ) => {
    const currency = CURRENY_COUNTRY_LABELS[destinationCountry] || GLOBAL_CURRENCY
    let boxOrders = []
    switch (selectedService.type) {
      case SERVICE_TYPE.MMCCB2C:
        boxOrders = buildBoxesForB2COrder(vItemisedOrders, currency, destinationCountry)
        break
      case SERVICE_TYPE.MMCCB2B:
        boxOrders = buildBoxesForB2BOrder(vItemisedOrders, currency, destinationCountry)
        break
      default:
        // B2B Bundle
        boxOrders = Object.values(vItemisedOrders)
        break
    }
    updateOCState({
      allOrders: aOrders,
      validOrders: vItemisedOrders,
      invalidOrders: inItemisedOrders,
      validRows: vRows,
      invalidRows: inRows,
      fileName: uploadedFileName,
      numberOfValidItemsInValidOrders,
      numberOfInvalidItemsInInvalidOrders,
      numberOfValidItemsInInvalidOrders,
      errorsByBoxLevel,
      errorsByParcelLevel,
      boxOrders
    })
  }

  return (
    <>
      {!ocMethod && <OCMethodSelection onMethodChange={method => changeMethod(method)} />}
      {ocMethod === OCMethod.UPLOAD && (
        <>
          <FileUpload
            destinationCountry={selectedService.destination_country}
            allOrders={allOrders}
            validOrders={validOrders}
            invalidOrders={invalidOrders}
            validRows={validRows}
            invalidRows={invalidRows}
            fileName={fileName}
            serviceType={selectedService.type}
            onMethodChange={handleClickOptionButton}
            onProcessOrders={handleProcessDataUpload}
          />
        </>
      )}
      {ocMethod === OCMethod.KEYBOARD && (
        <>
          <ManualKeyboard />
        </>
      )}
    </>
  )
}

export { OrdersStep }
